import { Grid, Stack, Typography } from '@mui/material';
import PortalModal from '../../common/PortalModal';
import { FormTextField } from '../../common/Form/FormTextField';
import { useState } from 'react';

export default function PersonalZoomLinkModal({ isOpen, toggleModalOpen, id, onConfirm, course }) {
  const [personalZoomLink, setPersonalZoomLink] = useState('');

  //Θ(1) check whether Zoom link is valid
  const isValidURL = () => {
    try {
      new URL(personalZoomLink);
      return true;
    } catch (ex) {
      return false;
    }
  };

  return (
    <PortalModal
      title={'Switch to Personal Zoom'}
      maxWidth="md"
      isOpen={isOpen}
      onClose={toggleModalOpen}
      isCloseable
      primaryButtonTitle="Add"
      isPrimaryButtonDisabled={!personalZoomLink}
      onPrimaryClick={() => onConfirm(personalZoomLink)}
      secondaryButtonTitle="Cancel"
      onSecondaryClick={toggleModalOpen}
      id={`${id}__modal`}
    >
      <Grid
        id={`${id}__grid_container`}
        container
        direction="column"
        spacing={2}
        sx={{
          justifyContent: 'center',
        }}
      >
        {course && (
          <Grid item id={`${id}__grid_item_text`} xs={12} xl={3}>
            <Typography id={`${id}__text`} variant="small">
              {`Provide personal zoom meeting url to switch to for the meetings of ${course.SUBJECT_CODE} ${course.COURSE_NUMBER} - ${course.CRN}.`}
            </Typography>
          </Grid>
        )}
        <Grid item id={`${id}__grid_item_inputText`} xs={12} xl={3}>
          <FormTextField
            id={`${id}__inputText_zoomLink`}
            label="Personal Zoom link URL"
            required
            value={personalZoomLink}
            placeholder="https://odu.zoom.us/..."
            onChange={(value) => setPersonalZoomLink(value)}
            errorText="URL must start with https://"
            helperText="URL must start with https://"
            error={!isValidURL() && personalZoomLink.length > 0}
            textAlign={{ xs: 'start' }}
            labelGridProps={{ xs: 12, md: 2 }}
            inputGridProps={{ xs: 12, md: 10 }}
          />
        </Grid>
      </Grid>
    </PortalModal>
  );
}
